import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Popover from "@mui/material/Popover";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

import IconArrowDown from "./icon-arrow-down.svg";
import IconClose from "./icon-close.svg";

export const Container = styled.div``;

export const StyledButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding: 12px;

  border: 1px solid #000000;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 10px;

    padding-block: 4px;
    padding-inline: 8px;
  }
`;

export const ButtonText = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  white-space: nowrap;
  text-transform: capitalize;
`;

export const StyledIconArrowDown = styled(IconArrowDown)``;

export const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    border-radius: 12px;

    background: #f6f6f6;

    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

    ${theme.breakpoints.up("tablet")} {
      max-inline-size: 303px;
    }
  }
`;

export const PopoverHeader = styled.div`
  display: flex;
  justify-content: flex-end;

  padding: 11px;
`;

export const StyledIconClose = styled(IconClose)`
  cursor: pointer;
`;

export const PopoverMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  padding-block-end: 36px;
  padding-inline: 20px;
`;

const itemLinkStyle = css`
  color: #000000;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  text-transform: capitalize;
`;

export const MenuTitle = styled(BaseLink)`
  ${itemLinkStyle}
  display: inline-block;

  :hover {
    text-decoration: underline;
  }
`;

export const MenuTitleStatic = styled.div`
  ${itemLinkStyle}
  color: #727272;
  font-weight: 700;
`;

export const Divider = styled.div`
  inline-size: 100%;
  border-block-start: 1px solid #000000;
`;

export const LabelAndItemLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LabelHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const ItemLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 8px;
`;

export const StyledEntityLink = styled(EntityLink)<{ $isActive?: boolean }>`
  ${itemLinkStyle}

  &:not(:last-of-type) {
    padding-inline-end: 8px;
    border-inline-end: 2px solid #d7d7d7;
  }

  ${props =>
    props.$isActive &&
    css`
      color: #727272;
      font-weight: 700;
    `}

  :hover {
    text-decoration: underline;
  }
`;

export const StyledBaseLink = styled(BaseLink)<{ $isActive?: boolean }>`
  ${itemLinkStyle}

  ${props =>
    props.$isActive &&
    css`
      color: #727272;
      font-weight: 700;
    `}

  :hover {
    text-decoration: underline;
  }
`;

export const VideoSectionMenuContainer = styled.div``;
